import styled from 'styled-components';
import { config } from '../../../components/dashboards/config';
import { MOBILE_WIDTH } from 'datastake-daf/src/constants/Style';

export default styled.div`
  display: flex;
  flex-direction: column;

  .go-select-cont {
    padding: var(--size-lg);
    position: sticky;
    top: 0;
    background: ${config.DASHBOARD_BACKGROUND};
    z-index: 801;
  }

  .sections-cont {
    display: flex;
    flex-direction: column;
    gap: var(--size-lg);
    padding: var(--size-lg);
    padding-top: 0px;
    flex: 1;
    overflow: auto;

    @media(${MOBILE_WIDTH}) {
      gap: var(--size);
      padding: var(--size);
    }

    &.w-pt {
      padding-top: var(--size-lg);

      @media(${MOBILE_WIDTH}) {
        padding-top: var(--size);
      }
    }
  }
  
  .leaflet-bottom {
    z-index: 500;
  }

  &.no-padding {
    .sections-cont {
      padding: 0px;
      gap: 0px;

      .sections {
        padding: var(--size-lg);
        display: flex;
        flex-direction: column;
        gap: var(--size-lg);
      }
    }
  }

  section {
    display: flex;
    flex-wrap: wrap;
    gap: var(--size-lg);

    @media(${MOBILE_WIDTH}) {
      flex-direction: column;
      gap: var(--size);
    }

    .widget {
      flex: 1;

      &.dds-widget {
        min-width: 400px;
      }
    }
  }
  
  .nowrap {
    flex-wrap: nowrap;
  }

  &.own-data-collapsed {
    .overflow-section {
      max-width: calc(100vw - 48px - 250px);
      overflow-x: auto;
    }

    .dds-items {
      max-width: calc(100vw - 128px - 250px);
      overflow-x: auto;
    }
  }

  &.own-data-not-collapsed {
    .overflow-section {
      max-width: calc(100vw - 48px - 20px);
      overflow-x: auto;
    }

    .dds-items {
      max-width: calc(100vw - 128px);
      overflow-x: auto;
    }
  }

  &.collapsed {
    .overflow-section {
      max-width: calc(100vw - 48px - 250px);
      overflow-x: auto;
    }

    .dds-items {
      max-width: calc(100vw - 128px - 250px);
      overflow-x: auto;
    }
  }

  &.not-collapsed {
    .overflow-section {
      max-width: calc(100vw - 48px - 20px);
      overflow-x: auto;
    }

    .dds-items {
      max-width: calc(100vw - 128px);
      overflow-x: auto;
    }
  }

  .no-wrap {
    flex-wrap: nowrap;
  }
`;
